import { apiService } from '@/shared/services/apiServices';
import { TASK_FORM_ERROR_MESSAGES } from '../errors/errorMessages';
import type { TaskFormListResponse } from '../types';
import taskFormEndpoints from './taskFormEndpoints';

export interface ListTaskFormsInput {
  page?: number;
  limit?: number;
  search?: string;
}

export interface ListTaskFormsResult {
  success: boolean;
  data?: TaskFormListResponse;
  error?: string;
}

export async function listTaskForms(
  input: ListTaskFormsInput = {}
): Promise<ListTaskFormsResult> {
  try {
    const params = new URLSearchParams();
    if (input.page) {
      params.set('page', String(input.page));
    }
    if (input.limit) {
      params.set('limit', String(input.limit));
    }
    if (input.search) {
      params.set('search', input.search);
    }

    const url = params.toString()
      ? `${taskFormEndpoints.FORMS}?${params.toString()}`
      : taskFormEndpoints.FORMS;

    const result = await apiService.getAPI(url);

    if (!result.error) {
      return { success: true, data: result.data as TaskFormListResponse };
    }

    if (result.isNetworkError) {
      return { success: false, error: TASK_FORM_ERROR_MESSAGES.NETWORK_ERROR };
    }

    return { success: false, error: TASK_FORM_ERROR_MESSAGES.DEFAULT_ERROR };
  } catch {
    return { success: false, error: TASK_FORM_ERROR_MESSAGES.UNEXPECTED_ERROR };
  }
}
